import clsx from 'clsx'
import {DA1_UNIVERSAL_LOGIN_PATH} from 'common/HelperFunctions'
import {BUILD_VERSION} from 'common/constants'
import {useEffect} from 'react'
import {Link, Outlet} from 'react-router'

import {toAbsoluteUrl} from '_metronic/helpers'

const DA1_AUTH_GRADIENT = 'linear-gradient(90.14deg, #0D0E12 20.07%, #431214 99.87%)'

const UniversalLoginLayout = () => {
  useEffect(() => {
    document.title = 'Da1Timetable - Sign In'
    document.body.classList.add('app-ready')
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed position-relative min-vh-100'
      data-selective-ai-domain='true'
      style={{
        background: DA1_AUTH_GRADIENT,
        backgroundSize: 'cover',
      }}
    >
      {/* Logo sits in normal flow above the card (not absolutely positioned)
          so the login card can never overlap/hide it on small screens. */}
      <Link
        to={DA1_UNIVERSAL_LOGIN_PATH}
        className='align-self-start p-10 pb-0 text-decoration-none d-flex align-items-center gap-2 text-white fw-bold fs-4'
      >
        <img
          src={toAbsoluteUrl('/media/auth/image 70.png')}
          alt='Da1Timetable'
          style={{maxHeight: '48px'}}
        />
        Timetable™
      </Link>

      {/* 'safe center': centred, but top-aligned once the card outgrows the viewport so nothing is pushed into unreachable overflow. */}
      <div
        className='d-flex flex-center flex-column flex-column-fluid p-10 pt-4 pb-lg-20 position-relative'
        style={{justifyContent: 'safe center'}}
      >
        <div
          className={clsx('w-100 shadow-sm mx-auto mw-680px p-8 p-lg-12')}
          style={{
            background: 'rgba(40, 30, 35, 0.9)',
            backdropFilter: 'blur(16px)',
            borderRadius: 24,
            border: '1.5px solid rgba(59, 130, 246, 0.55)',
            marginTop: '1.5rem',
            boxShadow: '0 0 32px rgba(59, 130, 246, 0.12)',
            maxWidth: 680,
          }}
        >
          <Outlet />
        </div>
      </div>

      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex gap-5 align-items-center fw-bold fs-6 text-white'>
          <div>Build: {BUILD_VERSION}</div>
        </div>
      </div>
    </div>
  )
}

export {UniversalLoginLayout}
